import { HoofdstukSchema } from '@/api';
import {
  RegularBug,
  RegularDroplet,
  RegularLeaf,
  RegularShovel,
  RegularTrafficCone,
} from '@/icons/components';
import { ArrayElement } from '@/utils/typescript/arrayElement';

export type Grondslag = ArrayElement<typeof GRONDSLAGEN>;

/**
 * These are all the grondslagen that exist in the BE.
 * We have these in the FE as well because we need to map the grondslag to an icon.
 */
export const GRONDSLAGEN = [
  {
    label: 'Bodem',
    icon: RegularShovel,
    id: 'f4fca89b-3a85-4e45-b984-a76f2bc0feab',
  },
  {
    label: 'Milieu',
    icon: RegularLeaf,
    id: '31169dce-03f3-49fc-afa1-6c967852b214',
  },
  {
    label: 'Natuur',
    icon: RegularBug,
    id: 'ac72fbdc-c37f-4457-9983-f8b3dd5086c6',
  },
  {
    label: 'Ruimtelijke ordening',
    icon: RegularTrafficCone,
    id: '279b3de7-4e05-45af-bdcc-6a59eb25c151',
  },
  {
    label: 'Water',
    icon: RegularDroplet,
    id: 'a1d3443b-6dd5-42ea-8e70-ee4c9ca83350',
  },
] as const;

export const GRONDSLAGEN_MAP = GRONDSLAGEN.reduce(
  (acc, grondslag) => {
    acc.set(grondslag.id, grondslag);
    return acc;
  },
  new Map() as Map<string, Grondslag>
);

export const groupHoofdstukkenByGrondslag = (
  hoofdstukken: HoofdstukSchema[]
) => {
  const groupedHoofdstukken = GRONDSLAGEN.map((grondslag) => {
    const hoofdstukkenForGrondslag = hoofdstukken.filter(
      (hoofdstuk) => hoofdstuk.Grondslag === grondslag.id
    );

    if (hoofdstukkenForGrondslag.length === 0) {
      return null;
    }

    return {
      data: grondslag,
      hoofdstukken: hoofdstukkenForGrondslag,
    };
  }).filter(
    (
      grondslag
    ): grondslag is { data: Grondslag; hoofdstukken: HoofdstukSchema[] } =>
      Boolean(grondslag)
  );

  return groupedHoofdstukken;
};
